module.exports = __webpack_public_path__ + "static/media/60gb.8a0920d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/60gb.png
// module id = 80
// module chunks = 0